import classNames from 'classnames';
import { FC } from 'react';

import Section from './Section';
import { SectionProps } from './type';

const NoPageImageSection: FC<SectionProps> = ({ children, className, ...props }) => {
  const cn = classNames(className, 'no-page-image');

  return (
    <Section {...props} className={cn}>
      {children}
    </Section>
  );
};

export default NoPageImageSection;
